import styled from "@emotion/styled";

export const CreateDepartmentModalContainer = styled.div`
    width: 400px;
    gap: 1rem;
    color: #000000;
    position: relative;
    padding: 2rem 1.5rem;
    border-radius: 0.75rem;
    background-color: #ffffff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

    @media (min-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const CreateDepartmentModalContentContainer = styled.div`
    overflow-y: auto;
    max-height: 35em;
`;

export const CreateDepartmentModalTitle = styled.h1`
    font-size: 22px;
    margin-top: 5px;
    margin-bottom: 0px;
`;

export const CreateDepartmentModalContentWrapper = styled.div`
    margin-top: 1rem;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
`;

export const Input = styled.input`
    padding: 0.75rem;
    border-radius: 0.375rem;
    font-size: 0.9em;
    border: 1px solid #d8c0c0;
    width: 100%;
    margin: 20px;
`;

export const Button = styled.button<{
    backgroundColorHex?: string;
}>`
    width: 150px;
    text-transform: capitalize;
    padding: 0.75rem 1.125rem;
    border-radius: 0.375rem;
    font-size: 0.9em;
    font-weight: 600;
    color: rgb(255, 255, 255);
    background-color: ${(props) => props.backgroundColorHex ?? "#E5E7EB"};
    text-decoration: none;
    font-family: Helvetica, Arial, sans-serif;
    border: navajowhite;
`;
